"use client"

import { useEffect } from "react"

import { Button } from "@/components/ui/Button"
import { Card } from "@/components/ui/Card"
import { Container } from "@/components/ui/Container"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log error to console in development
    // eslint-disable-next-line no-process-env -- Need to check environment for development logging
    if (process.env.NODE_ENV === "development") {
      console.error("Error boundary caught:", error)
    }
  }, [error])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-20">
      <Container size="md">
        <Card padding="lg" className="text-center">
          <div className="text-6xl mb-6">⚠️</div>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            エラーが発生しました
          </h2>
          <p className="text-gray-600 mb-6">
            申し訳ございません。予期しないエラーが発生しました
            <br />
            もう一度お試しください
          </p>
          <div className="flex gap-4 justify-center">
            <Button onClick={reset} variant="primary">
              再試行
            </Button>
            <Button
              onClick={() => {
                window.location.replace("/")
              }}
              variant="outline"
            >
              ホームに戻る
            </Button>
          </div>
          {/* eslint-disable-next-line no-process-env -- Need to check environment for development error display */}
          {process.env.NODE_ENV === "development" && error.message && (
            <div className="mt-6 p-4 bg-red-50 rounded-lg text-left">
              <p className="text-sm text-red-800 font-mono">{error.message}</p>
            </div>
          )}
        </Card>
      </Container>
    </div>
  )
}
